import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);


var store = new Vuex.Store({
    state: {
      wxOpenId: '',
      wxState: '',
      userName: '',
      userInfo:{
        // user_id:'4314'
        // user_id:'1'
      },
      subOrderInfo:{

      },
      pageBelong:'',
      shopCount:0,
      curOrderType:'all',
      eidtAddrData: {
        ca_city:"",
        ca_county:"",
        ca_id:"",
        ca_if_default:"0",
        ca_mobile:"",
        ca_name:"",
        ca_phone:"",
        ca_province:"",
        ca_street:""
      },
      selectedAddrData:{
        ca_city:"",
        ca_county:"",
        ca_id:"",
        ca_if_default:"0",
        ca_mobile:"",
        ca_name:"",
        ca_phone:"",
        ca_province:"",
        ca_street:""
      },
      eidtInvoiceAddrData:{
        cia_city:"",
        cia_county:"",
        cia_id:"",
        cia_if_default:"0",
        cia_mobile:"",
        cia_name:"",
        cia_phone:"",
        cia_province:"",
        cia_street:""
      },
      selectedInvoiceAddrData:{
        cia_city:"",
        cia_county:"",
        cia_id:"",
        cia_if_default:"0",
        cia_mobile:"",
        cia_name:"",
        cia_phone:"",
        cia_province:"",
        cia_street:""
      },
      eidtInvoiceData: {
        ci_addr: "",
        ci_bank: "",
        ci_bknum: "",
        ci_id: "",
        ci_if_default: "1",
        ci_phone: "",
        ci_title: "",
        ci_type: "1",
        ci_vatno: "",
      },
      selectedInvoiceData: {
        ci_addr: "",
        ci_bank: "",
        ci_bknum: "",
        ci_id: "",
        ci_if_default: "1",
        ci_phone: "",
        ci_title: "",
        ci_type: "1",
        ci_vatno: "",
      }
    },
    mutations: {
        setWxOpenId(state,wxOpenId){
            state.wxOpenId = wxOpenId;
        },
        setWxState(state,wxState){
            state.wxState = wxState;
        },
        setUserName(state,userName){
            state.userName = userName;
        },
        setSubOrderInfo(state,subOrderInfo){
            state.subOrderInfo = subOrderInfo;
        },
        setUserInfo(state,userInfo){
            state.userInfo = userInfo;
        },
        setPageBelong(state,pageBelong){
            state.pageBelong = pageBelong;
        },
        setShopCount(state,shopCount){
            state.shopCount = shopCount;
        },
        setCurOrderType(state,curOrderType){
            state.curOrderType = curOrderType;
        },
        setEidtAddrData(state,eidtAddrData){
            state.eidtAddrData = eidtAddrData;
        },
        setSelectedAddrData(state,selectedAddrData){
            state.selectedAddrData = selectedAddrData;
        },
        setEidtInvoiceAddrData(state,eidtInvoiceAddrData){
          state.eidtInvoiceAddrData = eidtInvoiceAddrData;
        },
        setSelectedInvoiceAddrData(state,selectedInvoiceAddrData){
            state.selectedInvoiceAddrData = selectedInvoiceAddrData;
        },
        setEidtInvoiceData(state,eidtInvoiceData){
            state.eidtInvoiceData = eidtInvoiceData;
        },
        setSelectedInvoiceData(state,selectedInvoiceData){
            state.selectedInvoiceData = selectedInvoiceData;
        }
    }
});


export default store



// WEBPACK FOOTER //
// ./src/store.js